import React, { useEffect, useState } from "react";
import axios from "axios";
import { Megaphone, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SiteBannerNotice = ({ onOpen }) => {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    axios.get(`${API}/content/banner`).then((r) => setBanner(r.data)).catch(() => setBanner(null));
  }, []);

  const on = banner?.enabled !== false && !!banner?.message;
  return (
    <div
      data-testid="promos-site-banner-notice"
      className={`border rounded-md p-3 text-xs leading-relaxed flex flex-col sm:flex-row sm:items-center gap-3 ${
        on ? "bg-amber-500/10 border-amber-500/30 text-amber-100" : "bg-white/[0.03] border-white/10 text-white/60"
      }`}
    >
      <Megaphone size={16} className="flex-shrink-0 text-amber-400" />
      <p className="flex-1">
        {on ? (
          <>
            La <strong>« Bannière du site »</strong> est activée : c&apos;est elle qui s&apos;affiche en haut du site (avec le compte à rebours Flexfuel).
            Le bandeau des promotions ci-dessous n&apos;apparaît donc plus en haut de l&apos;accueil — les promos restent visibles dans la section Promotions.
          </>
        ) : (
          <>Le texte du bandeau rouge en haut du site et son compte à rebours se modifient dans la « Bannière du site ».</>
        )}
      </p>
      <button
        type="button"
        onClick={onOpen}
        data-testid="promos-open-site-banner"
        className="inline-flex items-center gap-1.5 px-3 py-2 rounded-md bg-[#FF3B30] text-white font-semibold hover:bg-[#FF3B30]/90 transition-colors whitespace-nowrap self-start sm:self-auto"
      >
        Modifier la Bannière du site <ArrowRight size={14} />
      </button>
    </div>
  );
};
